export default __webpack_public_path__ + "static/DSC_0266-c00fbaad4553539aaf16f658be710b0a.jpg";